<template>
  <div class="bar-percentage" :style="wrapperStyle">
    <h1 class="bar-percentage__title" v-if="title">{{title}}</h1>
    <!-- Top Legends -->
    <div class="bar-percentage__legends" :style="legendStyle" v-if="!isTopLegends">
      <div class="bar-percentage__legends__legend" v-for="(data, headerIndex) in percentageData" :key="headerIndex">
        <div class="square" :style="{'background-color': data.color}"></div>
        <div class="label">{{data.header}}</div>
      </div>
    </div>
    <div v-if="percentageData.length > 0" class="bar-percentage__percentage-wrapper">
      <div class="bar-percentage__percentage-wrapper__percentage" :style="percentageStyle" v-for="(data, barIndex) in percentageData" :key="barIndex">
        <div class="wrap">
          <div class="bar" :style="[{width: data.percent + '%'}, {'background-color': data.color}]"></div>
          <span class="caption">{{data.percent}}%</span>
        </div>
      </div>
    </div>
    <div v-else class="bar-percentage__percentage-nodata" >
      <p> Data not available</p>
    </div>
    <!-- Bottom Legends -->
    <div class="bar-percentage__legends" :style="legendStyle" v-if="isTopLegends">
      <div class="bar-percentage__legends__legend" v-for="(data, headerIndex) in percentageData" :key="headerIndex">
        <div class="square" :style="{'background-color': data.color}"></div>
        <div class="label">{{data.header}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-barpercentage',
  components: {

  },
  props: {
    wrapperStyle: {
      required: false,
      type: Object,
      default: () => {
        return {
          "width": "316px",
        }
      },
    },
    legendStyle: {
      required: false,
      type: Object,
      default: () => {
        return {
          "display": "flex"
        }
      },
    },
    percentageStyle: {
      required: false,
      type: Object,
      default: () => {
        return {
          "margin-bottom": "16px"
        }
      },
    },
    title: {
      required: false
    },
    percentageData: {
      required: true
    },
    isTopLegends: {
      required: false
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>